import script from "./ProductDetailRichText.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetailRichText.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetailRichText.vue?vue&type=style&index=0&id=33d99023&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33d99023"]])

export default __exports__